import React from 'react';
import PropTypes from 'prop-types';

import { Card } from 'core/components/card';
import { Label } from 'core/components/label';
import { PriceDetails } from '../price-details';
import { Slot, PolicyCardSlot } from '../slots';
import useStyles from './policy-card.styles';

/**
 * One policy on Modify Quote's left column (#36357): title, price details, and the named slots the
 * rest of the Policy cards lane fills (see ../slots/slots.js). Slot order follows the Figma card.
 */
const PolicyCard = ({ policy }) => {
  const classes = useStyles();
  const titleId = `policy-card-${policy.key}-title`;
  return (
    <Card type="secondary" component="section" aria-labelledby={titleId} className={classes.card}>
      <div className={classes.title}>
        <img src={policy.icon} alt="" className={classes.icon} />
        <div className={classes.titleText}>
          <Label type="body1" component="h3" id={titleId} className={classes.policyName}>
            {policy.title}
          </Label>
          <Label type="body3" className={classes.term}>
            {`${policy.termMonths} months`}
          </Label>
        </div>
      </div>
      <Slot name={PolicyCardSlot.EligibilityIssues} policy={policy} />
      <Slot name={PolicyCardSlot.Callouts} policy={policy} />
      <div className={classes.content}>
        <Slot name={PolicyCardSlot.EffectiveDate} policy={policy} />
        <div className={classes.details}>
          <PriceDetails policy={policy} />
          <Slot name={PolicyCardSlot.BillingDetails} policy={policy} />
          <Slot name={PolicyCardSlot.MortgageLender} policy={policy} />
        </div>
      </div>
    </Card>
  );
};

PolicyCard.propTypes = {
  policy: PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    termMonths: PropTypes.number.isRequired
  }).isRequired
};

export default PolicyCard;
